module.exports = __webpack_public_path__ + "img/cross3red.b4327cae.png";